import type { IncidentPriority, IncidentStatus } from '../types/incident.types'

export const STATUS_LABELS: Record<IncidentStatus, string> = {
  DRAFT: 'Draft',
  NEW: 'New',
  ACKNOWLEDGE: 'Acknowledge',
  IN_PROGRESS: 'In Progress',
  BLOCKED: 'Blocked',
  DONE: 'Done',
  CLOSED: 'Closed',
}

export const STATUS_DOT_CLASS: Record<IncidentStatus, string> = {
  DRAFT: 'bg-status-draft',
  NEW: 'bg-status-new',
  ACKNOWLEDGE: 'bg-status-acknowledge',
  IN_PROGRESS: 'bg-status-in-progress',
  BLOCKED: 'bg-status-blocked',
  DONE: 'bg-status-done',
  CLOSED: 'bg-status-closed',
}

export const STATUS_TEXT_CLASS: Record<IncidentStatus, string> = {
  DRAFT: 'text-status-draft',
  NEW: 'text-status-new',
  ACKNOWLEDGE: 'text-status-acknowledge',
  IN_PROGRESS: 'text-status-in-progress',
  BLOCKED: 'text-status-blocked',
  DONE: 'text-status-done',
  CLOSED: 'text-status-closed',
}

export const STATUS_BUTTON_CLASS: Record<IncidentStatus, string> = {
  DRAFT: 'border-status-draft text-status-draft hover:bg-status-draft hover:text-white',
  NEW: 'border-status-new text-status-new hover:bg-status-new hover:text-white',
  ACKNOWLEDGE: 'border-status-acknowledge text-status-acknowledge hover:bg-status-acknowledge hover:text-white',
  IN_PROGRESS: 'border-status-in-progress text-status-in-progress hover:bg-status-in-progress hover:text-white',
  BLOCKED: 'border-status-blocked text-status-blocked hover:bg-status-blocked hover:text-white',
  DONE: 'border-status-done text-status-done hover:bg-status-done hover:text-white',
  CLOSED: 'border-status-closed text-status-closed hover:bg-status-closed hover:text-white',
}

export const PRIORITY_LABELS: Record<IncidentPriority, string> = {
  CRITICAL: 'Critical',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
}

export const PRIORITY_DOT_CLASS: Record<IncidentPriority, string> = {
  CRITICAL: 'bg-priority-critical',
  HIGH: 'bg-priority-high',
  MEDIUM: 'bg-priority-medium',
  LOW: 'bg-priority-low',
}

export const PRIORITY_TEXT_CLASS: Record<IncidentPriority, string> = {
  CRITICAL: 'text-priority-critical',
  HIGH: 'text-priority-high',
  MEDIUM: 'text-priority-medium',
  LOW: 'text-priority-low',
}
